
import { Component, Vue, Watch } from "vue-property-decorator";
import Restaurant from "@/domain/restaurant/Restaurant";
import StatCard from "@/components/stats/StatCard.vue";
import StatGraph from "@/components/stats/StatGraph.vue";
import Stats from "@/domain/Stats";
import WorkingHours from "@/domain/restaurant/WorkingHours";
import TimeService from "@/services/TimeService";
import RemoteServices from "@/services/RemoteServices";
import BookingViewDatePicker from "@/components/booking/components/BookingViewDatePicker.vue";
@Component({
  components: { BookingViewDatePicker, StatGraph, StatCard }
})
export default class StatsView extends Vue {
  stats = new Stats();

  workingHours: WorkingHours | null = null;

  workingHoursList: WorkingHours[] = [];

  date: Date = new Date();

  loading = true;

  timeout: ReturnType<typeof setTimeout> = setTimeout(() => {}, 1);

  dateBeforeTimeout: Date = this.date;

  created() {
    this.updateSelectedRestaurant();
  }

  mounted() {
    this.getStats();
  }

  @Watch("selectedRestaurant")
  updateSelectedRestaurant() {
    const restaurant = this.selectedRestaurant;
    if (
      restaurant != null &&
      restaurant.workingHours != null &&
      restaurant.workingHours.length > 0
    ) {
      this.workingHoursList = restaurant.workingHours;
      this.workingHours = restaurant.workingHours[0];
    } else {
      this.workingHoursList = [];
      this.workingHours = null;
    }
  }

  @Watch("workingHours")
  async getStats() {
    if (this.workingHours != null) {
      this.loading = true;
      try {
        this.stats = await RemoteServices.getStatsByWorkingHours(
          this.workingHours,
          TimeService.getISODateString(this.date)
        );
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
      this.loading = false;
    } else {
      console.log("DashBoard: getStats: WorkingHours is null");
    }
  }

  startChangeDateTimeout() {
    clearTimeout(this.timeout);
    this.loading = true;
    this.stats = new Stats();
    this.dateBeforeTimeout = new Date(this.date);
    this.timeout = setTimeout(this.refreshIfDateNotChanged, 500);
  }

  refreshIfDateNotChanged() {
    if (this.dateBeforeTimeout.getTime() === this.date.getTime()) {
      this.dateBeforeTimeout = new Date();
      this.getStats();
    }
  }

  updateDate(newDate: Date) {
    this.date = newDate;
    this.startChangeDateTimeout();
  }

  get hasSelectedRestaurant() {
    return this.selectedRestaurant != null;
  }

  get selectedRestaurant(): Restaurant | null {
    return this.$store.getters.getSelectedRestaurant;
  }
}
